import { render } from "./input-text-number-currency.html?vue&type=template&id=2eb5bd38&scoped=true&ts=true&external"
import script from "./input-text-number-currency.ts?vue&type=script&lang=ts&external"
export * from "./input-text-number-currency.ts?vue&type=script&lang=ts&external"

import "./input-text-number-currency.scss?vue&type=style&index=0&id=2eb5bd38&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb5bd38"]])

export default __exports__